import { FormItem, Title } from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { memo, useCallback } from 'react';
import { AppPanels } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { setActivePanel } from 'src/entity/ActivePanel';

import bridge from '@vkontakte/vk-bridge';
import { NominationsT, setCurrentNomination } from 'src/entity/Pretendents';
import { $secondStageLabels } from 'src/entity/Pretendents/model/Pretendents';
import { CustomButton } from 'src/shared/ui/custom-button';
import styles from './styles.module.scss';

export interface INominationCard {
  name: NominationsT;
  label: string;
}

export const NominationCard = memo(
  ({ name, label }: INominationCard) => {
    const [
      onSetCurrentNomination,
      onSetActivePanel,
      secondStageLabels
    ] = useUnit([
      setCurrentNomination,
      setActivePanel,
      $secondStageLabels
    ]);

    const onButtonClick = useCallback(() => {
      onSetCurrentNomination(name);
      onSetActivePanel(AppPanels.SECOND_STAGE_VOITING);
      // @ts-ignore
      bridge.send('VKWebAppSendCustomEvent', {
        type: 'nomination_click',
        json: JSON.stringify({
          screen: 'nominationsList',
          nomination: label
        })
      });
    }, [onSetCurrentNomination, name, onSetActivePanel, label]);

    return (
      <FormItem key={name} className={styles.vote_card}>
        <Title className={styles.input_label} weight='3' level='2'>
          {label}
        </Title>
        <CustomButton
          className={styles.button}
          customMode={secondStageLabels?.[name] ? 'selected' : 'secondary'}
          type='button'
          size='m'
          onClick={onButtonClick}
        >
          {secondStageLabels?.[name]
            ? String(secondStageLabels[name])
            : 'Перейти'}
        </CustomButton>
      </FormItem>
    );
  }
);
